var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import $ from 'jquery';
import { DOMcreateElement } from '../typescript/TSXDomParse';
import { handleize, notNullAndLengthy } from '../typescript/helpers';
import NavLink from './NavLink';
import NavMenuColumn from './NavMenuColumn';
export default function NavMenu(props) {
    var _this = this;
    var _a, _b, _c, _d;
    var data = props.data, level = props.level, isMobile = props.isMobile;
    var activeClass = 'active';
    var trigger = handleize((_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.text.toLowerCase()) + "-" + level;
    var hasChildren = notNullAndLengthy((_b = data.fields) === null || _b === void 0 ? void 0 : _b.components);
    var hasChildrenClass = '';
    if (hasChildren) {
        hasChildrenClass = " has-children has-dropdown " + (isMobile ? 'expandable' : '');
    }
    var toggleClass = function (el, className) {
        var classListFunction;
        if (el.classList.contains(className)) {
            classListFunction = 'remove';
        }
        else {
            classListFunction = 'add';
        }
        el.classList[classListFunction](className);
    };
    var click = function (event) { return __awaiter(_this, void 0, void 0, function () {
        var target, isCurrentlyOpen, parentEl, parentParentEl, children, activeChildren, _i, activeChildren_1, el;
        var _a, _b;
        return __generator(this, function (_c) {
            if (window.ORW.utilities.isMobile() === false)
                return [2 /*return*/];
            if (hasChildren)
                event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            target = event.target;
            isCurrentlyOpen = target.classList.contains('opened');
            parentEl = target.parentElement;
            parentParentEl = (_a = $(parentEl).parents('.children')) === null || _a === void 0 ? void 0 : _a[0];
            if (!parentParentEl) {
                parentParentEl = (_b = $(parentEl).parent()) === null || _b === void 0 ? void 0 : _b[0];
            }
            children = target.nextElementSibling;
            // Level-1: Children are wrapped with .dropdown-wrapper, if children is
            // dropdown-wrapper grab its nested .children
            if (children.classList.contains('dropdown-wrapper')) {
                children = children.querySelector('.children');
            }
            activeChildren = parentParentEl.querySelectorAll('.children.active');
            for (_i = 0, activeChildren_1 = activeChildren; _i < activeChildren_1.length; _i++) {
                el = activeChildren_1[_i];
                if (el !== event.target) {
                    $(el).slideUp();
                }
            }
            // - Remove any active menus
            parentParentEl.querySelectorAll('.active').forEach(function (el) {
                el.classList.remove('active');
            });
            // - Remove any opened menus
            parentParentEl.querySelectorAll('.opened').forEach(function (el) {
                el.classList.remove('opened');
            });
            if (isCurrentlyOpen)
                return [2 /*return*/];
            // Add 'opened' class to target
            target.classList.add('opened');
            // Open menu
            toggleClass(children, 'active');
            $(children).slideToggle();
            // Dropdown parent (.expandable) needs to be activated in order to
            // set opacity: 1 for children
            parentEl.classList.add('active');
            return [2 /*return*/];
        });
    }); };
    var hover = function (_a) {
        var target = _a.target, type = _a.type;
        var parentEl = target.parentNode;
        if (type === 'mouseenter') {
            parentEl.classList.add(activeClass);
        }
        else if (type === 'mouseleave') {
            parentEl.classList.remove(activeClass);
        }
    };
    /*
     * For Desktop, activate on mouse hover.
     * For Mobile, activate on click.
     */
    var triggers = {};
    if (isMobile) {
        triggers = {
            onClick: click,
        };
    }
    else {
        triggers = {
            onMouseEnter: hover,
            onMouseLeave: hover,
        };
    }
    return (DOMcreateElement("div", { className: "level-" + level + hasChildrenClass },
        DOMcreateElement(NavLink, __assign({}, triggers, { trigger: trigger, level: level !== null && level !== void 0 ? level : 1, expandable: hasChildren, text: (_c = data.fields) === null || _c === void 0 ? void 0 : _c.text, url: (_d = data.fields) === null || _d === void 0 ? void 0 : _d.url })),
        hasChildren ? (DOMcreateElement("div", { className: "dropdown-wrapper" },
            DOMcreateElement(NavMenuColumn, { isMobile: isMobile, clickFunction: click, components: data.fields.components, level: level }))) : ('')));
}
